import { PropsWithChildren, ReactNode, Suspense } from 'react';

import LayoutErrorBoundary from './LayoutErrorBoundary';
import LayoutLoader from './LayoutLoader';

import css from './Layout.module.css';

export interface LayoutBodyProps extends PropsWithChildren {
  fallback?: ReactNode;
}

export default function LayoutBody({ children, fallback }: LayoutBodyProps) {
  return (
    <main className={css.main}>
      <div className={css.container}>
        <div className={css.content}>
          <LayoutErrorBoundary>
            <Suspense fallback={fallback || <LayoutLoader />}>
              {children}
            </Suspense>
          </LayoutErrorBoundary>
        </div>
      </div>
    </main>
  );
}
